module.exports = __webpack_public_path__ + "static/sliderm_1-fc3c1c794ffc42ec205e0ee83a8bd39a.jpg";